<template>
  <b-row>
    <b-col cols="12" md="7" lg="8">
      <b-skeleton-wrapper :loading="newsPost === null">
        <div v-if="newsPost">
          <h1>{{ newsPost.title }}</h1>
          <h2 class="small text-muted">
            Posted in
            <router-link
              :to="{
                name: 'PostsSection',
                params: { sectionSlug: newsPost.section_slug },
              }"
            >
              {{ newsPost.section_title }}
            </router-link>
            on {{ formattedDate }} by {{ newsPost.user }}
          </h2>
          <picture>
            <source :srcset="darkImgUrl" media="(prefers-color-scheme: dark)" />
            <b-img
              v-if="newsPost.image_url"
              :src="newsPost.image_url"
              fluid-grow
              rounded
              class="mb-3"
            ></b-img>
          </picture>
          <div v-html="parsedMarkdown"></div>
        </div>
        <template #loading>
          <b-skeleton height="4em" width="100%" class="mb-4" />
          <b-skeleton-img aspect="2:1" />
        </template>
      </b-skeleton-wrapper>
    </b-col>
    <b-col
      v-if="newsPosts === null || newsPosts.length"
      class="single-post-other-news"
    >
      <h3>Other news</h3>
      <NewsWidgetResponsive
        :newsPosts="newsPosts"
        :newsPostCount="newsPostCount"
        cols="1"
        breakpoint="md"
      />
    </b-col>
  </b-row>
</template>

<script>
import NewsWidgetResponsive from "@/components/NewsWidgetResponsive.vue";

import api from "@/api";
import markdown from "@/mixins/markdown";
import dateFormat from "@/mixins/dateFormat";

export default {
  name: "SinglePost",
  metaInfo() {
    const title = this.newsPost?.title || "News post";
    return {
      title,
    };
  },
  mixins: [markdown, dateFormat],
  components: { NewsWidgetResponsive },
  props: {
    postSlug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      newsPostCount: 6,
    };
  },
  asyncComputed: {
    async newsPost() {
      const data = await api.getPost(this.postSlug);
      return data;
    },
    async newsPosts() {
      const data = await api.getPosts({ perPage: this.newsPostCount });
      return data.posts.filter((post) => post.slug !== this.postSlug);
    },
  },
  computed: {
    formattedDate() {
      return this.formatDate(this.newsPost.created_on, "MMMM D, YYYY");
    },
    parsedMarkdown() {
      return this.parseMarkdown(this.newsPost.text);
    },
    darkImgUrl() {
      try {
        return this.newsPost.image_url.replace(/\.([^.]*)$/, "@dark.$1");
      } catch {
        return this.newsPost.image_url;
      }
    },
    postLoadError() {
      return this.$asyncComputed?.newsPost?.error;
    },
  },
  watch: {
    postLoadError(isError) {
      if (isError) this.$router.replace("/error");
    },
  },
};
</script>

<style lang="scss">
.single-post-other-news {
  .news-post.card {
    max-height: 24em;
    overflow: scroll;
  }
}
</style>
